// translate router.meta.title, be used in breadcrumb sidebar tagsview
export function generateTitle(title, type = 'menu.') {
  const hasKey = this.$te(type + title)

  if (hasKey) {
    // $t :this method from vue-i18n, inject in @/lang/index.js
    const translatedTitle = this.$t(type + title)

    return translatedTitle
  }
  return title
}
